import { RaasPortalId } from "./types";

export const RAAS_TOOL_KEYS = {
  DecisionAgent: "decision_agent",
  Presentation: "presentation",
} as const;

export type RaasToolKey =
  (typeof RAAS_TOOL_KEYS)[keyof typeof RAAS_TOOL_KEYS];

export interface IRaasToolItem {
  icon: string;
  key: RaasToolKey;
  label: string;
}

export const RAAS_TOOL_ITEMS: readonly IRaasToolItem[] = [
  { icon: "psychology", key: RAAS_TOOL_KEYS.DecisionAgent, label: "Decision Agent" },
  { icon: "layers", key: RAAS_TOOL_KEYS.Presentation, label: "Presentation" },
];

export const isRaasToolAgentKey = ({
  key,
}: {
  key?: string;
}): boolean =>
  key === RAAS_TOOL_KEYS.DecisionAgent || key === RAAS_TOOL_KEYS.Presentation;

export const getRaasToolItem = ({
  key,
}: {
  key?: string;
}): IRaasToolItem | undefined =>
  RAAS_TOOL_ITEMS.find((item) => item.key === key);

export const getToolItemsForPortal = ({
  portalId,
}: {
  portalId?: RaasPortalId;
}): readonly IRaasToolItem[] =>
  RAAS_TOOL_ITEMS.filter(
    (item) =>
      item.key !== RAAS_TOOL_KEYS.DecisionAgent ||
      portalId === RaasPortalId.Internal,
  );
